import { useState, useEffect, useCallback } from 'react';
import { flattened } from '@app/utils/utils';
import { useIntl } from 'react-intl';

export const useIntlMessage = (...idList) => {
  const [intlMessages, setIntlMessages] = useState([]);
  const [intlKeys, setIntlKeys] = useState([]);
  const intl = useIntl();

  const setKeys = useCallback(() => {
    setIntlKeys(flattened(idList));
  }, [idList]);

  useEffect(() => {
    const messages = intlKeys.map(key =>
      typeof key === 'object' ? intl.formatMessage({ id: key.id }, { ...key.values }) : intl.formatMessage({ id: key }),
    );
    setIntlMessages(messages);
  }, [intl, intlKeys]);

  useEffect(setKeys, []);

  return intlMessages;
};

export default useIntlMessage;
